import ReportIcon from "./images/icons/DangerTriangle.svg?react";
import HideIcon from "./images/icons/eye.svg?react";
import ShareIcon from "@/common/images/icons/share_icon.svg?react";
import CollectionIcon from "./images/icons/bookmark.svg?react";
import ManageIcon from "@/common/images/icons/manage_icon.svg?react";
import StackIcon from "@/common/images/icons/stack.svg?react";
import GearIcon from "./images/icons/gear.svg?react";
import FlagIcon from "./images/icons/flag.svg?react";
import CheckIcon from "@/common/images/icons/check.svg?react";
import CrossIcon from "@/common/images/icons/cross.svg?react";
import { Roles } from "@/common/buses/popups/popup-types";
import { IGif, INicheFeedbackResponse } from "@/common/services/types";
import { CurrentUserObject } from "@/common/hooks/useVisitorInfo";
import { RepostInfo } from "@/components/gifPreview/RepostInfo";

interface IOptions {
  actions: {
    handleHideGif: () => void;
    handleManageClick: () => void;
    toggleCollection: () => void;
    toggleReport: () => void;
    toggleShareMenu: () => void;
    handleOpenEditNichesDialog: (role: Roles) => void;
    handleOpenEditGif: () => void;
    handleOpenTagFeedback: () => void;
    toggleGifPrefs: () => void;
    toggleNiche: () => void;
    handleRelevantVote: () => void;
    handleIrrelevantVote: () => void;
  };
  currentUser: CurrentUserObject | null;
  gif: IGif;
  isNicheContentModerator: boolean;
  isFeedbackEnabled: boolean;
  shouldDisplayVoteButtons: boolean;
  gifFeedback?: INicheFeedbackResponse;
}

export const getMoreMenuData = ({
  actions,
  currentUser,
  gif,
  isNicheContentModerator,
  isFeedbackEnabled,
  shouldDisplayVoteButtons,
  gifFeedback
}: IOptions) => {
  const {
    handleHideGif,
    handleManageClick,
    toggleCollection,
    toggleReport,
    toggleShareMenu,
    handleOpenEditNichesDialog,
    handleOpenEditGif,
    handleOpenTagFeedback,
    toggleGifPrefs,
    toggleNiche,
    handleRelevantVote,
    handleIrrelevantVote,
  } = actions;

  const isAuth = !!currentUser;
  const isCM = !!currentUser?.isContentManager();
  const isThisUserGif = isAuth && gif.userName === currentUser?.username;
  const isGifPublished = gif.published === true;

  const groupName = gifFeedback ? () => <RepostInfo createDate={gifFeedback.timestamp} userName={gifFeedback.userName} /> : null;

  return [
    {
      groupName,
      groupMobileName: groupName,
      items: [
        {
          icon: ShareIcon,
          title: "Share",
          onClick: toggleShareMenu
        },
        ...(shouldDisplayVoteButtons ? [{
          icon: CheckIcon,
          title: "Relevant",
          onClick: handleRelevantVote,
        }] : []),
        ...(shouldDisplayVoteButtons ? [{
          icon: CrossIcon,
          title: "Irrelevant",
          onClick: handleIrrelevantVote,
        }] : []),
        ...(isAuth ? [{
          icon: StackIcon,
          title: "Add to a Niche",
          onClick: toggleNiche,
          disabled: !isGifPublished
        }] : []),
        ...(isThisUserGif && gif.niches.length > 0 ? [{
          icon: ManageIcon,
          title: "Change Niches",
          disabled: !isGifPublished,
          onClick: () => handleOpenEditNichesDialog(Roles.owner),
        }] : []),
        ...(isAuth && !isThisUserGif && isNicheContentModerator ? [{
          icon: ManageIcon,
          title: "Change Niches",
          onClick: () => handleOpenEditNichesDialog(Roles.moderator),
        }] : []),
        ...(isAuth ? [{
          icon: CollectionIcon,
          title: "Add to a Collection",
          onClick: toggleCollection
        }] : []),
        {
          icon: ReportIcon,
          title: "Report",
          onClick: toggleReport
        },
        ...(isAuth && isFeedbackEnabled ? [{
          icon: FlagIcon,
          title: "Flag Irrelevant Tags",
          onClick: handleOpenTagFeedback
        }] : []),
        ...(isCM ? [{
          icon: HideIcon,
          title: "Hide",
          onClick: handleHideGif
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Change Niches",
          onClick: () => handleOpenEditNichesDialog(Roles.admin),
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Type",
          onClick: toggleGifPrefs,
        }] : []),
        ...(isThisUserGif ? [{
          icon: ManageIcon,
          title: "Manage Uploads",
          onClick: handleManageClick,
        }] : []),
        ...(isThisUserGif && currentUser.verified ? [{
          icon: ManageIcon,
          title: "Manage Links",
          onClick: () => handleOpenEditGif(),
        }] : []),
      ]
    }
  ];
};
